import React from 'react'
import { Box, Text } from '@chakra-ui/react'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  function handleScroll() {
    const pageTop =
      document.documentElement.scrollTop || document.body.scrollTop
    const pageBottom = pageTop + window.innerHeight
    const fadeups = document.querySelectorAll('.fade_up')

    fadeups.forEach((fade_up) => {
      if (fade_up.getBoundingClientRect().top < pageBottom) {
        fade_up.classList.add('visible')
      } else {
        fade_up.classList.remove('visible')
      }
    })
  }

  document.addEventListener('scroll', handleScroll)

  return (
    <Box
      className='fade_up'
      direction='row'
      py={{ base: '2', md: 'auto' }}
      px={{ base: '2', md: 'auto' }}
      w='100%'
      mx='auto'
      my='50px'
      textAlign='center'>
      <Text fontSize='20px'>Copyright &copy; Bintuseze 2023.</Text>
    </Box>
  )
}

export default Footer
